import { unref, computed } from 'vue';
import type { ComputedRef, MaybeRef } from 'vue';
import { areValuesEqual } from '../../../shared/utils';
import type { TrackBy } from '../../../shared/types';

interface UseValuesCompareReturn {
  equal: ComputedRef<boolean>;
  notEqual: ComputedRef<boolean>;
}

export function useValuesCompare(
  value1: MaybeRef<unknown>,
  value2: MaybeRef<unknown>,
  trackBy?: TrackBy,
): UseValuesCompareReturn {
  const equal = computed<boolean>(() => {
    return areValuesEqual(unref(value1), unref(value2), trackBy);
  });

  const notEqual = computed(() => !equal.value);

  return {
    equal,
    notEqual,
  };
}
